/* mono-zen landing page
   1. Supplies the Tailwind Play CDN with the design tokens used by the
      mono-zen-* sections (colors, spacing, typography).
   2. Drives the scroll-reveal animation and in-page smooth scrolling.

   Loaded (deferred) AFTER https://cdn.tailwindcss.com in layout/theme.liquid,
   so `window.tailwind` already exists here. Assigning `tailwind.config`
   triggers the CDN to re-scan the DOM and generate the custom classes. */

   if (window.tailwind) {
    window.tailwind.config = {
        theme: {
            extend: {
                colors: {
                    secondary: "#6b5c45",
                    "surface-container": "#f2ede9",
                    "primary-fixed-dim": "#d4c4ac",
                    "on-error-container": "#93000a",
                    "on-tertiary": "#ffffff",
                    error: "#ba1a1a",
                    "on-error": "#ffffff",
                    "on-tertiary-container": "#6b5039",
                    "tertiary-fixed-dim": "#e4c0a3",
                    "primary-fixed": "#f1e0c6",
                    "on-secondary-fixed-variant": "#53452f",
                    "surface-container-highest": "#e7e1de",
                    "on-surface": "#1d1b19",
                    "surface-container-lowest": "#ffffff",
                    "surface-tint": "#695d49",
                    "on-primary": "#ffffff",
                    "surface-container-high": "#ede7e4",
                    "surface-dim": "#ded9d6",
                    background: "#fef8f5",
                    "on-secondary": "#ffffff",
                    "surface-bright": "#fef8f5",
                    surface: "#fef8f5",
                    "inverse-surface": "#32302e",
                    "on-secondary-fixed": "#241a08",
                    "on-surface-variant": "#4c463d",
                    "primary-container": "#d9c9b0",
                    primary: "#695d49",
                    "secondary-container": "#f2ddbf",
                    "on-tertiary-fixed": "#2a1705",
                    "error-container": "#ffdad6",
                    "surface-container-low": "#f8f2ef",
                    "surface-variant": "#e7e1de",
                    "inverse-on-surface": "#f5f0ec",
                    "on-primary-fixed": "#221a0b",
                    "secondary-fixed-dim": "#d8c4a7",
                    "tertiary-container": "#e9c4a7",
                    "on-tertiary-fixed-variant": "#5b422c",
                    "secondary-fixed": "#f5dfc2",
                    "inverse-primary": "#d4c4ac",
                    "outline-variant": "#cec5ba",
                    "on-background": "#1d1b19",
                    outline: "#7d766c",
                    "on-primary-container": "#5f5440",
                    "tertiary-fixed": "#ffdcc0",
                    "on-primary-fixed-variant": "#504532",
                    tertiary: "#745941",
                    "on-secondary-container": "#706049",
                },
                borderRadius: {
                    DEFAULT: "0.25rem",
                    lg: "0.5rem",
                    xl: "0.75rem",
                    full: "9999px",
                },
                spacing: {
                    "margin-desktop": "64px",
                    "section-gap": "128px",
                    "container-max": "1440px",
                    unit: "8px",
                    "margin-mobile": "24px",
                    gutter: "32px",
                },
                fontFamily: {
                    "label-sm": ["Inter"],
                    "headline-lg": ["Playfair Display"],
                    "label-caps": ["Inter"],
                    "body-lg": ["Inter"],
                    "body-md": ["Inter"],
                    "headline-lg-mobile": ["Playfair Display"],
                    "display-lg": ["Playfair Display"],
                    "display-md": ["Playfair Display"],
                },
                fontSize: {
                    "label-sm": ["14px", { lineHeight: "1.4", fontWeight: "500" }],
                    "headline-lg": ["40px", { lineHeight: "1.2", letterSpacing: "0.02em", fontWeight: "400" }],
                    "label-caps": ["12px", { lineHeight: "1.2", letterSpacing: "0.15em", fontWeight: "600" }],
                    "body-lg": ["18px", { lineHeight: "1.8", letterSpacing: "0.01em", fontWeight: "400" }],
                    "body-md": ["16px", { lineHeight: "1.6", fontWeight: "400" }],
                    "headline-lg-mobile": ["32px", { lineHeight: "1.2", fontWeight: "400" }],
                    "display-lg": ["80px", { lineHeight: "1.1", letterSpacing: "0.04em", fontWeight: "400" }],
                    "display-md": ["56px", { lineHeight: "1.1", letterSpacing: "0.02em", fontWeight: "400" }],
                },
            },
        },
    };
}


const initmonozen = () => {
  const revealEls = document.querySelectorAll(".reveal-on-scroll");

  if (revealEls.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          const delay = Number(entry.target.dataset.delay) || 0;
          setTimeout(() => entry.target.classList.add("active"), delay);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    for (const el of revealEls) {
      observer.observe(el);
    }
  }

  for (const anchor of document.querySelectorAll('a[href^="#"]')) {
    const href = anchor.getAttribute("href");
    if (!href || href === "#") continue;

    anchor.addEventListener("click", (event) => {
      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
    });
  }
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initmonozen);
} else {
  initmonozen();
}
